<template>
  <div v-if="store.getters.getInUseCompanyHasAccount || store.getters.getInUseCompanyHasTaxAgency">
    <div v-if="isAuthenticated && !isLoading">
      <div v-if="!store.getters.getInUseCompanyHasActiveSubscription">
        <v-btn v-if="store.getters.getShowLarge" color="blue-darken-4" size="small" class="ma-1" variant="elevated"
          @click="handleLogin">
          Suscríbete
          <v-badge color="#ffffff" :content="'quedan ' + days + ' días'" inline overlap>
          </v-badge>

        </v-btn>
        <v-btn v-else color="blue-darken-4" size="small" class="ma-1" variant="elevated" @click="handleLogin">
          <v-icon icon="mdi-bell-ring"> </v-icon></v-btn>
      </div>
    </div>
  </div>
  <div v-else>
    <v-overlay :model-value="overlayActivo" class="overlay-center">
      <v-container class="text-center">
        <v-img src="/src/assets/img/vecti-logo-solo-100px-transparent.png" max-width="100"
          class="logo-animation"></v-img>
      </v-container>
    </v-overlay>
  </div>
</template>

<script setup>
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";

const ret = ref(null);
const days = ref(0);
const router = useRouter();

const overlayActivo = ref(false);
const { loginWithPopup, isAuthenticated, isLoading } = useAuth0();

const inUseCompany = computed(() => store.getters.getInUseCompany);


onMounted(async () => {
  console.log("onmountedc");
  try {
    console.log("store.getters.getInUseCompan y: " + store.getters.getInUseCompany);
    if (!store.getters.getInUseCompany) {
      console.log("no hay company");
      return;
    }
    console.log("companyId: " + JSON - inUseCompany.value);
    ret.value = await getDaysEndSubscription(inUseCompany.value);

    //console.log("days: " + JSON.stringify(days));
    console.log("days: " + ret?.value);
    console.log("days ->: " + ret?.value?.type?.daysToEnd);
    days.value = ret?.value?.type?.daysToEnd;

  } catch (e) {
    console.log("Error en vecti_user (header): " + e);
  }
});


watch(inUseCompany, (newValue) => {
  console.log("store.getters.getInUseCompany cambio: ", newValue);
  if (newValue) {
    console.log("newValue: ", newValue);
    getDaysEndSubscription(newValue).then((result) => {
      console.log("result days: " + JSON.stringify(result));
      days.value = result?.type?.daysToEnd;
    });
  }
});

watch(days, (newValue) => {
  console.log("days cambio: ", JSON.stringify(newValue));
  console.log("newValue?.type?.daysToEnd : ", newValue);
  if (newValue?.type?.daysToEnd > 0) {
    days.value = newValue;
  }

});

const handleLogin = () => {
  try {
    console.log("Suscribete");
    router.push("/subscriptions");
  } catch (error) {
    console.error("Error en suscribete:", error);
  }
};
</script>
<style scoped>
/*  
.overlay-center {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}
*/
.overlay-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo-animation {
  animation: fadeAndScale 5s linear infinite;
  align-items: center;
  justify-content: center;
  width: 150px;
  /* Ajusta el tamaño del logo */
}

@keyframes fadeAndScale {
  0% {
    opacity: 0;
    transform: scale3d(0.75, 0.75, 1);
  }

  50% {
    opacity: 1;
    transform: scale3d(0.75, 0.75, 1);
  }

  100% {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
}
</style>
